/* eslint-disable react/function-component-definition */
/* Global imports. */
import React, {useRef, useState, useEffect} from "react"
import { Link } from "gatsby"
import Buy from "@components/Buy"
import EditionImage from "@components/EditionImage"
import {isPreOrder, truncateString} from "@src/helpers"
import { getFormat } from "@src/onix"

interface Props {
  jacketImage?: string;
  jacketImageRemote?: string;
  alternativeJacketImage?: string;
  height?: number;
  width?: number;
  primaryAuthorName: string;
  title: string;
  description?: string;
  isbn: string;
  author: string;
  format?: string;
  imprint?: string;
  publicationDate?: Date;
  displayAuthor?: boolean;
  displayDescription?: boolean;
  displayBuyButton?: boolean;
  editionUrl?: string;
  authorUrl?: string;
  referringComponentID?: string;
  isPanMacmillanTitle?: boolean;
  referringSlug?: string;
  customURL?: string;
}

const BookSpotlightCollectionItem = ({ title, jacketImage, jacketImageRemote, alternativeJacketImage, width, height, primaryAuthorName, description, isbn, author, format, imprint, publicationDate, displayAuthor=true, displayBuyButton=false, displayDescription=false, editionUrl, authorUrl, referringComponentID, isPanMacmillanTitle, referringSlug, customURL  }: Props) => {
  const [isActive, setIsActive] = useState(false);
  const resolvedFormat = getFormat(format)
  return <figure className="relative sm:flex sm:flex-wrap sm:justify-center text-center">
  <div>
  <span className="relative inline-block mb-6">
  {alternativeJacketImage ? 
  <img src={alternativeJacketImage} alt={`Book cover for ${title}`} />:
<Link to={`/${editionUrl}`} 
className="no-underline tm-jacket" 
data-ref-component-type={`bookspotlight-collection`} 
data-ref-component-id={referringComponentID} 
data-title={title} 
data-isbn={isbn} 
data-author={primaryAuthorName} 
data-format={resolvedFormat} 
data-ispanmac={isPanMacmillanTitle ? "yes" : "no"}
data-ref-slug={referringSlug}
><EditionImage isbn={isbn} title={title} altImagePath={jacketImageRemote} height={height} width={width} /></Link>
  }
  </span>
  {displayBuyButton && (
    <>
      {customURL ? (
        <div className="pt-4 mt-[-1.5rem] book-spotlight__buttons book-spotlight__buttons--desktop">
          <a
            href={customURL}
            className="!pl-4 !pr-8 !py-3 h-[3rem] text-left  !font-bold  !rounded-md bg-green hover:bg-green-light border-solid border border-green hover:border-green-light text-white !block !visible overflow-hidden"
            target="_blank"
            rel="noopener noreferrer"
            data-ref-component-type={`bookspotlight-collection-custom-url`}
            data-ref-component-id={referringComponentID}
            data-title={title}
            data-isbn={isbn}
            data-author={primaryAuthorName}
            data-format={resolvedFormat}
            data-ispanmac={isPanMacmillanTitle ? "yes" : "no"}
            data-ref-slug={referringSlug}
          >
           <span className="inline-block pb-[0.75rem]">Buy</span>
           <span className="whitespace-pre inline-block"> the book</span>
          </a>
        </div>
      ) : ( format && imprint && publicationDate ) ? (
        <div className="pt-4 mt-[-1.5rem] book-spotlight__buttons book-spotlight__buttons--desktop">
          <Buy
            referringComponent="bookspotlight-collection"
            referringComponentID={referringComponentID}
            isbn={isbn}
            author={primaryAuthorName}
            title={title}
            format={format}
            imprint={imprint}
            isPreOrder={isPreOrder(publicationDate)}
            isPanMacmillanTitle={isPanMacmillanTitle ? "yes" : "no"}
            data-ref-slug={referringSlug}
          />
        </div>
      ) : null }
    </>
  )}
  <figcaption className="text-center pt-4">
    <h3 className="mb-2 text-lg !leading-6 sm:text-xl bold [overflow-wrap:anywhere]">{editionUrl ? <Link to={`/${editionUrl}`} className="!no-underline hover:text-[#999999] tm-title" data-ref-slug={referringSlug} data-ref-component-type={`bookspotlight-collection`} data-ref-component-id={referringComponentID} data-format={resolvedFormat} data-title={title} data-isbn={isbn} data-author={primaryAuthorName} data-ispanmac={isPanMacmillanTitle ? "yes" : "no"}>{title}</Link> : `${title}`}</h3>
    {displayAuthor && (
      primaryAuthorName && editionUrl ? <p className="mb-0 font-sans text-xs"><Link to={`/${editionUrl}`} className="!no-underline hover:text-[#999999] tm-author" data-ref-slug={referringSlug} data-ref-component-type={`bookspotlight-collection`} data-ref-component-id={referringComponentID} data-format={resolvedFormat} data-title={title} data-isbn={isbn} data-author={primaryAuthorName} data-ispanmac={isPanMacmillanTitle ? "yes" : "no"}><span dangerouslySetInnerHTML={{ __html: primaryAuthorName }} /></Link></p> : primaryAuthorName && <p className="mb-0 font-sans text-xs" dangerouslySetInnerHTML={{ __html: primaryAuthorName }} ></p>
    )}
  </figcaption>
    {displayDescription && description && (
      <>
        <span className={`bookspotlight--description ${isActive ? "" : "line-clamp-4"}`} dangerouslySetInnerHTML={{ __html: description}} />
        <span className="inline-block mt-3 mb-4 text-red" onClick={() => setIsActive(!isActive)}>{isActive ? 'Read less' : 'Read more'}</span>
      </>
      )}
  </div>

  
</figure>;
};

export default BookSpotlightCollectionItem;
